import { Grid } from '@material-ui/core';
import CommonModal from '../../components/CommonModal';
import { useState, useEffect, Fragment } from 'react';
import { CloseOutlined } from '@material-ui/icons';
import './index.scss';
import { getLenderSessionUrl } from '../../api/onboarding'
import { createClearDuesSession } from '../../api/challan';

const PayEarlierModal = ({ open, closeModal, refetchData }) => {

    const [loading, setLoading] = useState(false);
    const [sessionData, setSessionData] = useState({});

    useEffect(() => {
      setLoading(true);
      // getLenderSessionUrl().then(res => {
      //   setSessionData(res)
      //   setLoading(false)
      // })
      createClearDuesSession().then(res => {
        setSessionData(res)
        setLoading(false)
      })
    },[])

    const renderModalContent = () => {
      if(loading) {
        return <Fragment>
          Loading...
        </Fragment>
      } else {
        return <Grid container>
          <Grid md={8}>
            <div className="modalMain">
              <iframe src={sessionData.url} />
            </div>
          </Grid>
        </Grid>
      }
    }

    const onModalClose = () => {
      refetchData()
      closeModal();
    }

    return (
      <CommonModal maxWidth="xl" open={open} style={{width: '100%'}}>
        <div onClick={() => { onModalClose() }} className="modalCloseBtn">
          <CloseOutlined />
        </div>
        {renderModalContent()}
      </CommonModal>
    )
}

export default PayEarlierModal;